<template>
  <div v-if="isEmptySearchedVaTest" class="px-2.5">
    <div class="grid grid-cols-2 gap-2">
      <TestCard
        v-for="node in sortedVaRootNodeList"
        :key="node.id"
        :test-group-node="node"
        :expand-icon="getExpandIcon(node.value)"
        :select-prop="selectProp"
        :is-not-allowed-select-prop="isNotAllowedSelectProp"
        :order-test-support-obj="orderTestSupportObj"
        class="mb-3"
      />
    </div>
  </div>
  <TestCard
    v-else
    ref="vaTest"
    :key="rootForSearchedVaTest.id"
    class="ml-2.5 searched-test w-1/3"
    :test-group-node="rootForSearchedVaTest"
    :filtered-test="searchedVaTest"
    :is-show-expand="true"
    :expand-icon="getExpandIcon(rootForSearchedVaTest.value)"
    :select-prop="selectProp"
    :is-not-allowed-select-prop="isNotAllowedSelectProp"
    :order-test-support-obj="orderTestSupportObj"
  />
</template>

<script>
import TestCard from "./TestCard.vue";
import _ from "lodash";

export default {
  name: "NewVaTestTabPane",
  components: {
    TestCard,
  },

  props: {
    rootForSearchedVaTest: {
      type: Object,
      default: () => ({}),
    },
    searchedVaTest: {
      type: Object,
      default: () => ({}),
    },
    screenWidth: {
      type: Number,
      default: 1440,
    },
    selectProp: {
      type: String,
      default: "isSelect",
    },
    isNotAllowedSelectProp: {
      type: String,
      default: "isNotAllowedSelect",
    },
    orderTestSupportObj: {
      type: Object,
      default: () => ({}),
    },
    vaRootNodeList: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      sortedVaRootNodeList: [],
      currentVaTestOrder: [],
    };
  },

  computed: {
    isEmptySearchedVaTest() {
      return _.isEmpty(this.rootForSearchedVaTest);
    },
  },

  watch: {
    vaRootNodeList(newVal) {
      if (!newVal || newVal.length === 0) {
        return;
      }
      this.sortedVaRootNodeList = newVal;
      this.sortVaNodeListByScreenWidth(this.screenWidth);
    },

    screenWidth(newVal) {
      this.sortVaNodeListByScreenWidth(newVal);
    },
  },

  mounted() {
    this.sortVaNodeListByScreenWidth(this.screenWidth);
  },

  methods: {
    // Split sorted VA root node list into 2 columns as evenly as possible
    columnNodes(index) {
      if (!this.sortedVaRootNodeList || this.sortedVaRootNodeList.length === 0) {
        return [];
      }
      const total = this.sortedVaRootNodeList.length;
      const half = Math.ceil(total / 2);
      return index === 1
        ? this.sortedVaRootNodeList.slice(0, half)
        : this.sortedVaRootNodeList.slice(half);
    },

    // sort va root node list according to screen width (reuse existing VA logic)
    sortVaNodeListByScreenWidth(screenWidth) {
      let order = [];
      switch (true) {
        case screenWidth < 1759:
          order = [
            1, 6, 18, 21, 22, 99, 198, 728, 14, 98, 23, 24, 199, 201, 65, 727, 51,
            118, 7, 732, 710, 202,
          ];
          break;
        case screenWidth < 2080:
          order = [
            1, 6, 14, 710, 18, 728, 21, 22, 7, 198, 23, 24, 732, 118, 199, 98, 99,
            65, 727, 51, 201, 202,
          ];
          break;
        default:
          this.sortedVaRootNodeList = this.vaRootNodeList;
          break;
      }

      if (_.isEqual(order, this.currentVaTestOrder) || order.length === 0) {
        return;
      }

      const sorted = _.sortBy(this.vaRootNodeList, (node) => _.indexOf(order, node.id));
      this.sortedVaRootNodeList = sorted;
      this.currentVaTestOrder = order;
    },

    // get expandIcon for va testGroup (copied from original VA tab pane)
    getExpandIcon(testGroup) {
      if ([98, 99, 727].includes(testGroup.id)) return "bulletList";
      const testNumberInTestGroup =
        (testGroup.packagePackages ? testGroup.packagePackages.length : 0) +
        (testGroup.packageTests ? testGroup.packageTests.length : 0);
      return testNumberInTestGroup === 0
        ? ""
        : testNumberInTestGroup < 25
          ? "arrowDown"
          : "newWindow";
    },
  },
};
</script>

<style scoped>
.searched-test {
  border: 2px solid #3498db;
  box-shadow: 0px 2px 6px rgba(48, 48, 48, 0.13);
}
</style>

